export default __webpack_public_path__ + "static/media/AppleCareLogo.8064cd3c.svg";